import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { LeagueService } from '../services/league.service';

@Component({
  selector: 'app-league-form',
  templateUrl: './league-form.component.html',
  styleUrls: ['./league-form.component.css']
})
export class LeagueFormComponent implements OnInit {

  @ViewChild('form') form: NgForm;
  @Input() league: League;
  @Input() parentLoading: boolean = false;
  @Input() parentError: string = '';
  @Output() updateLeague = new EventEmitter<NewLeague>();
  @Output() cancelEditLeague = new EventEmitter<void>();

  loading = true;
  err = '';
  gameTypes: GameTypeStub[] = [];
  leagueTypes: string[] = ['National', 'Venue-Based', 'City', 'State'];
  league_type: string = 'National';
  isSavingInfo: boolean = false;
  selectedVenues: TypeaheadOption[] = [];
  isLeagueEdit: boolean = false;
  newLeague: NewLeague = {
    league_name: '',
    league_venues: [],
    description: '',
    game_type: 'trivia',
    league_start: '',
    league_end: '',
    min_game: 0,
    max_game: 0,
    scoring_type: 'total_score',
    owner: '',
    city: '',
    state: '',
    latitude: 0,
    longitude: 0,
    distance: 0,
  };

  quillConfiguration = {
		toolbar: [
		  ['bold', 'italic', 'underline'],
		  ['blockquote'],
		  [{ list: 'ordered' }, { list: 'bullet' }],
		  [{ header: [1, 2, 3, 4, 5, 6, false] }],
		  ['link'],
		  ['clean'],
		],
	};

  successMessage: string = "";

  constructor(private leagueService: LeagueService) { }

  ngOnInit(): void {

    this.leagueService.fetchGameTypes()
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        (gameTypes: GameTypeStub[]) => {
          this.gameTypes = gameTypes.filter(gameType => gameType.league_eligible);
        },
        err => this.err = err.error.detail
      );
    if (this.league) {
      this.isLeagueEdit = true;
      this.newLeague.league_name = this.league.league_name;
      this.newLeague.league_start = this.league.league_start;
      this.newLeague.league_end = this.league.league_end;
      this.newLeague.scoring_type = this.league.scoring_type;
      this.newLeague.min_game = this.league.min_game;
      this.newLeague.max_game = this.league.max_game;
      this.newLeague.description = this.league.description;
      this.newLeague.game_type = this.league.game_type.code_name;
      this.newLeague.league_venues = [];
      this.newLeague.city = this.league.city;
      this.newLeague.state = this.league.state;
      this.newLeague.latitude = this.league.latitude;
      this.newLeague.longitude = this.league.longitude;
      this.newLeague.distance = this.league.distance;
      if (typeof this.newLeague.game_type !== 'string') this.newLeague.game_type = this.league.game_type.code_name;
      console.log(this.newLeague)
      if (this.league.league_venues.length) {
        this.league_type = 'Venue-Based';
        for (const venue of this.league.league_venues as TypeaheadOption[]) {
          if (!venue?.sid || !venue?.name) {
            console.error('Incorrect type for venue data', venue);
            continue;
          }
          else {
            this.selectedVenues.push({ name: venue.name, sid: venue.sid });
            this.newLeague.league_venues.push(venue.sid as number);
          }
        }
      } else if (this.league.city) {
        this.league_type = 'City';
      } else if (this.league.state) {
        this.league_type = 'State';
      } else {
        this.league_type = 'National';
      }
    }
  }

  handleVenueSelect(venue: TypeaheadOption) {
    this.selectedVenues.push(venue);
    this.newLeague.league_venues.push(venue.sid as number);
  }

  handleCitySelect(city: TypeaheadOption) {
    this.loading = true;
    this.leagueService.getPlaceCoordinates(city.sid as string)
    .pipe(finalize(() => this.loading = false))
    .subscribe(
      (coordinates: {lat: number, lng: number}) => {
        this.newLeague.latitude = coordinates.lat;
        this.newLeague.longitude = coordinates.lng;
        let cityParts = city.name.split(',');
        this.newLeague.city = cityParts[0];
        this.newLeague.state = cityParts[1].trim();
        this.newLeague.distance = 50;
      },
      err => this.err = err.error.detail
    );
  }

  clearCity() {
    this.newLeague.city = '';
    this.newLeague.latitude = 0;
    this.newLeague.longitude = 0;
    this.newLeague.distance = 0;
  }

  removeVenue(venue: TypeaheadOption) {
    this.selectedVenues = this.selectedVenues.filter(v => v.sid !== venue.sid);
    this.newLeague.league_venues = this.newLeague.league_venues.filter(v => v !== venue.sid);
  }

  conformLeagueValues(value: string) {
    if (value !== 'venue-based') {
      this.newLeague.league_venues = [];
      this.selectedVenues = [];
    }
    if (value !== 'city') {
      this.newLeague.city = '';
      this.newLeague.latitude = 0;
      this.newLeague.longitude = 0;
      this.newLeague.distance = 0;
    }
    if (value !== 'state' && value !== 'city') {
      this.newLeague.state = '';
    }
  }

  validateLeagueValues(form: NgForm) {
    if (this.league_type === 'City') {
      if (!this.newLeague.city) {
        this.err = 'City is required for city-based leagues';
        return;
      }
    }
    if (this.league_type === 'State') {
      if (!this.newLeague.state) {
        this.err = 'State is required for state-based leagues';
        return;
      }
    }
    if (this.league_type === 'Venue-Based') {
      if (!this.selectedVenues.length) {
        this.err = 'At least one venue is required for venue-based leagues';
        return;
      }
    }
    if (!form.valid) return;
    this.outputLeague();
  }

  outputLeague() {
    this.updateLeague.emit(this.newLeague);
  }

  emitCancelLeague() {
    this.cancelEditLeague.emit();
  }

}
